export default __webpack_public_path__ + "static/media/i189hp.d2efa8ea.webp";